import queryString from 'query-string'

export const getPathParams = (params: Record<string, string | undefined>, slug = '') => {
  // TODO: understand the usage of slug, and whether it should be added always.
  if ((slug || '').search(/\bmen\b/) >= 0) {
    // @i18n-ignore
    params.gender = 'men'
  }
  if ((slug || '').search(/\bwomen\b/) >= 0) {
    // @i18n-ignore
    params.gender = 'women'
  }
  const queryParams = queryString.stringify(params)
  return queryParams ? `?${queryParams}` : ''
}

export const removeQueryParams = (slug: string) => {
  const index = slug.indexOf('?')
  if (index > -1) {
    slug = slug.substr(index, slug.length)
  }
  return slug
}

export const isParamPresent = (pathSearchParams: URLSearchParams, key: string, isCaseSensitive = true) => {
  if (isCaseSensitive) {
    return pathSearchParams.has(key)
  } else {
    let isPresent = false
    for (const paramKey of pathSearchParams.keys()) {
      if (paramKey.toLowerCase() === key.toLowerCase()) {
        isPresent = true
      }
    }
    return isPresent
  }
}
